var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CV_pdf",
    "data-name": "CV pdf",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.222,
    height: 39.359,
    viewBox: "0 0 30.222 39.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M27.926,0H7.528C6.96,0,6.5.46,6.5,1.354v37.3a1.058,1.058,0,0,0,1.028.7H35.694a1.058,1.058,0,0,0,1.028-.7V9.121c0-.489-.065-.647-.181-.763L28.363.181A.621.621,0,0,0,27.926,0Z",
    transform: "translate(-6.5)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M37.5.151V8.479h8.328Z",
    transform: "translate(-15.713 -0.045)",
    fill: "#d9d7ca"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M18.891,25.474h0a1.128,1.128,0,0,1-.68-.229,1.684,1.684,0,0,1-.784-1.576c.128-1.144,1.543-2.342,4.206-3.562A47.178,47.178,0,0,0,24.3,12.552c-.7-1.527-1.383-3.507-.886-4.669a1.348,1.348,0,0,1,.8-.854,3.451,3.451,0,0,1,.714-.121c.354,0,.666.456.886.737.207.264.678.824-.262,4.781a22.458,22.458,0,0,0,3.576,5.315,13.673,13.673,0,0,1,2.36-.252c1.1,0,1.768.257,2.04.785a1.423,1.423,0,0,1-.274,1.518,1.868,1.868,0,0,1-1.56.837,4.672,4.672,0,0,1-2.96-1.606,33.676,33.676,0,0,0-6.2,1.983,19.942,19.942,0,0,1-1.675,2.988C20.127,25,19.506,25.474,18.891,25.474Zm1.871-3.6c-1.5.844-2.114,1.538-2.158,1.929-.007.065-.026.235.3.486C19.011,24.253,19.623,23.974,20.762,21.871Zm9.585-3.122c.573.441.713.663,1.087.663a1.06,1.06,0,0,0,.85-.31,1.113,1.113,0,0,0,.162-.292c-.086-.046-.2-.138-.826-.138A10.277,10.277,0,0,0,30.347,18.749ZM25.1,14.123a50.1,50.1,0,0,1-1.879,5.316,35.117,35.117,0,0,1,4.566-1.42A24.058,24.058,0,0,1,25.1,14.123ZM24.67,8.176a1.686,1.686,0,0,0,.067,2.26C25.4,8.95,24.7,8.166,24.67,8.176Z",
    transform: "translate(-9.744 -2.053)",
    fill: "#14a8bd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M35.694,50.948H7.528A1.028,1.028,0,0,1,6.5,49.92V39H36.722V49.92A1.028,1.028,0,0,1,35.694,50.948Z",
    transform: "translate(-6.5 -11.589)",
    fill: "#14a7bd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(6.496 30.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M16.9,50.006H15.744V42.924h2.037a2.859,2.859,0,0,1,.893.144,2.429,2.429,0,0,1,.793.432,2.257,2.257,0,0,1,.567.7,1.93,1.93,0,0,1,.216.918,2.511,2.511,0,0,1-.183.976,2.039,2.039,0,0,1-.51.735,2.3,2.3,0,0,1-.788.461,3.032,3.032,0,0,1-1.018.163H16.9v2.556Zm0-6.207V46.6h1.057a1.256,1.256,0,0,0,.418-.072,1.054,1.054,0,0,0,.38-.235,1.151,1.151,0,0,0,.278-.456,2.161,2.161,0,0,0,.105-.725,1.962,1.962,0,0,0-.048-.4,1.151,1.151,0,0,0-.2-.432,1.165,1.165,0,0,0-.418-.346,1.554,1.554,0,0,0-.711-.139H16.9Z",
    transform: "translate(-15.744 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M29.8,46.268a5.2,5.2,0,0,1-.188,1.494,3.715,3.715,0,0,1-.476,1.038,2.444,2.444,0,0,1-.649.659,3.253,3.253,0,0,1-.7.361,2.877,2.877,0,0,1-.615.154,4.1,4.1,0,0,1-.413.032H24.084V42.924h2.133a4.053,4.053,0,0,1,1.571.283,3.261,3.261,0,0,1,1.125.754,3.1,3.1,0,0,1,.668,1.071A3.547,3.547,0,0,1,29.8,46.268ZM26.381,49.16a1.909,1.909,0,0,0,1.691-.749,3.8,3.8,0,0,0,.519-2.172,3.678,3.678,0,0,0-.105-.874,1.87,1.87,0,0,0-.408-.783,2.155,2.155,0,0,0-.822-.567A3.538,3.538,0,0,0,25.91,43.8h-.673V49.16h1.144Z",
    transform: "translate(-18.222 -42.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M35.77,43.8v2.229h2.96v.788H35.77v3.19H34.6V42.924h4.429V43.8Z",
    transform: "translate(-21.347 -42.924)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.44593149eddcac23d5f4daab2bae4d8b.svg";
export { ForwardRef as ReactComponent };